(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  function initializeBlogPostCarousels() {
    document.querySelectorAll('.blog-post-carousel').forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;

      const list = carousel.querySelector('.blog-post-list--carousel');
      const previous = carousel.querySelector('[data-blog-carousel-previous]');
      const next = carousel.querySelector('[data-blog-carousel-next]');

      if (!list || !previous || !next) return;

      carousel.dataset.carouselInitialized = 'true';

      const updateControls = () => {
        const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
        previous.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        list.scrollBy({ left: direction * Math.max(260, list.clientWidth * 0.85), behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      list.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      updateControls();
    });
  }

  initializeBlogPostCarousels();
  document.addEventListener('shopify:section:load', initializeBlogPostCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-category-nav"] && !Shopify.designMode) return;
  try {
    
  function initializeMobileCategoryNav(nav) {
    if (nav.dataset.arrowsInitialized === 'true') return;

    const list = nav.querySelector('[data-category-nav-list]');
    const previous = nav.querySelector('[data-category-nav-previous]');
    const next = nav.querySelector('[data-category-nav-next]');

    if (!list || !previous || !next) return;

    nav.dataset.arrowsInitialized = 'true';

    const updateArrows = () => {
      const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      previous.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= maxScroll - 2;
    };

    const scrollCategories = (direction) => {
      list.scrollBy({ left: direction * Math.max(180, list.clientWidth * 0.7), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollCategories(-1));
    next.addEventListener('click', () => scrollCategories(1));
    list.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });
    updateArrows();
  }

  function initializeAllMobileCategoryNavs() {
    document.querySelectorAll('.mobile-category-nav').forEach(initializeMobileCategoryNav);
  }

  initializeAllMobileCategoryNavs();
  document.addEventListener('shopify:section:load', initializeAllMobileCategoryNavs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-accordion"]) return;
  try {
    
  class ProductDescriptionAccordion extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector("[data-product-description-source]");
      const target = this.querySelector("[data-product-description-items]");

      if (!source || !target || this.dataset.enhanced === "true") {
        return;
      }

      const productTitle = this.dataset.productTitle.trim().toLowerCase();
      const descriptionLabel = this.dataset.descriptionLabel;
      const groups = [];
      let currentGroup = { title: descriptionLabel, nodes: [] };

      const saveGroup = () => {
        const hasContent = currentGroup.nodes.some((node) => {
          return node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== "";
        });

        if (hasContent) {
          groups.push(currentGroup);
        }
      };

      Array.from(source.childNodes).forEach((node) => {
        const isElement = node.nodeType === Node.ELEMENT_NODE;
        const tagName = isElement ? node.tagName : "";
        const headingText = isElement ? node.textContent.trim() : "";
        const nestedHeading = isElement
          ? node.querySelector(":scope > h2:first-child, :scope > h3:first-child")
          : null;

        if (tagName === "H1" && headingText.toLowerCase() === productTitle) {
          return;
        }

        if (nestedHeading) {
          saveGroup();
          currentGroup = {
            title: nestedHeading.textContent.trim() || descriptionLabel,
            nodes: [node]
          };
          nestedHeading.remove();
          return;
        }

        if (tagName === "H2" || tagName === "H3") {
          saveGroup();
          currentGroup = {
            title: headingText || descriptionLabel,
            nodes: []
          };
          return;
        }

        currentGroup.nodes.push(node);
      });

      saveGroup();

      if (groups.length === 0) {
        return;
      }

      groups.forEach((group, index) => {
        const details = document.createElement("details");
        const summary = document.createElement("summary");
        const content = document.createElement("div");

        details.className = "product-description-accordion__item";
        summary.className = "product-description-accordion__summary";
        content.className = "product-description-accordion__content prose";
        summary.textContent = group.title;
        details.open = index === 0;

        group.nodes.forEach((node) => content.appendChild(node));
        details.append(summary, content);
        target.appendChild(details);
      });

      source.hidden = true;
      target.hidden = false;
      this.dataset.enhanced = "true";
      this.hideEmptyReviewBadges();
      window.addEventListener("load", () => this.hideEmptyReviewBadges(), { once: true });
    }

    hideEmptyReviewBadges() {
      document.querySelectorAll(".jdgm-prev-badge").forEach((badge) => {
        const owner = badge.closest("[data-number-of-reviews]");
        const rawCount = badge.dataset.numberOfReviews || owner?.dataset.numberOfReviews;
        const count = rawCount === undefined ? Number.NaN : Number(rawCount);
        const text = badge.textContent.replace(/\s+/g, " ").trim();

        if (count === 0 || /^no reviews?$/i.test(text)) {
          badge.hidden = true;
        }
      });
    }
  }

  if (!customElements.get("product-description-accordion")) {
    customElements.define("product-description-accordion", ProductDescriptionAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
